import RevvForm from "./RevvForm";

export default RevvForm;



// WEBPACK FOOTER //
// ./src/commonComponents/RevvForm/index.js